/**
 * Manufacturer defaults for the legacy internal design-order form.
 *
 * Fields must remain visible and editable for every user. Manufacturer
 * selection must never cause two users to receive different form controls.
 * The revised customer intake form has its own shared field component and
 * does not depend on this file.
 */

export const getManufacturerRules = () => ({
  autoSet: {},
  hidden: [],
  locked: [],
});
